import type { Priority, ProjectStatus } from '@brandschutz/shared';

const dateFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const numberFmt = new Intl.NumberFormat('de-DE');

export function formatDate(input: string | Date | null | undefined): string {
  if (!input) return '—';
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '—';
  return dateFmt.format(d);
}

export function formatDateTime(input: string | Date | null | undefined): string {
  if (!input) return '—';
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '—';
  return dateTimeFmt.format(d);
}

export function formatNumber(input: number | null | undefined): string {
  if (input == null) return '—';
  return numberFmt.format(input);
}

export function daysUntil(input: string | Date | null | undefined): number | null {
  if (!input) return null;
  const target = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(target.getTime())) return null;
  const now = new Date();
  const ms = target.getTime() - now.getTime();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

const STATUS_LABELS: Record<ProjectStatus, string> = {
  draft: 'Entwurf',
  planning: 'Planung',
  in_review: 'In Prüfung',
  approved: 'Freigegeben',
  completed: 'Abgeschlossen',
};

export function statusLabel(status: ProjectStatus): string {
  return STATUS_LABELS[status];
}

const PRIORITY_LABELS: Record<Priority, string> = {
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
};

export function priorityLabel(priority: Priority): string {
  return PRIORITY_LABELS[priority];
}

const ROLE_LABELS: Record<string, string> = {
  gast: 'Gast',
  ersteller: 'Ersteller',
  freigeber: 'Freigeber',
  admin: 'Administrator',
};

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

/**
 * Bytes in human-readable Form, deutsche Locale.
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
